export class LoanService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
	}

	getLoanResult(params) {
		return this.$http({
			method: 'POST',
			data: params,
			url: '/public/properties/loan'
		});
	}
}
